
import './style.scss'
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useEffect, useState } from 'react';
import { userStateData } from '../../data/userStateData';
import { interactionConnector } from '../../server/connector/interactionConnector';
import { setChatDataLoaded } from '../../redux/reducers/userSlice';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import DashboardToolHeader from '../../sections/dashboardToolHeader/DashboardToolHeader';
import DashboardToolEditArea from '../../sections/dashboardToolEditArea/DashboardToolEditArea';
import { analysisStateData } from '../../data/analysisStateData';

function DashboardVideoAnalysis() {
	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const [analysisDataLoaded, setAnalysisDataLoaded] = useState<boolean>(false)
	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(setSubPage(DashboardSubPages.VIDEO_TOOL_EDIT))
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked === true) {
			// confirm a user is logged in
			if (userStateData.loggedIn === false) {
				// TEMP: load analysis method which loads test data
				loadAnalysisData()
				// window.location.replace(PAGE_URLS.SEARCH)
			} else {
				// Load user data such as interactions data
				loadAnalysisData()
			}
		}
	}, [loginChecked])

	const loadAnalysisData = () => {
		analysisStateData.setAnalysisData({
			videoFileName: '1752939194095-SampleVideo_1280x720_5mb.mp4',
			feedbacks: []
		})
		setAnalysisDataLoaded(true)
		// const querySting: string = window.location.search;
		// const urlParams: URLSearchParams = new URLSearchParams(querySting)
		// const analysisId: string | null = urlParams.get('id')

		// if (!analysisId) {
		// 	console.log('[DashboardVideoAnalysis] - No analysis id provided')
		// } else {
		// 	if (interactionConnector.requestInProgress) {
		// 		console.log('[DashboardVideoAnalysis] - loadVideoData() called while requestInProgress')
		// 	} else {
		// 		if (analysisId) {
		// 			interactionConnector.performGetAnalysisDataRequest(analysisId).then((successRequest) => {
		// 				dispatch(setChatDataLoaded(true))
		// 				// setProfileRequestCompleted(true)
		// 				if (!successRequest) {
		// 					console.log('WARNING - [DashboardVideoAnalysis] - loadVideoData() failed')
		// 				}
		// 			})
		// 		}
		// 	}
		// }
	}

	return (
		<div className='dashboard-wrap dashboard-tool-wrap'>
			{loginChecked && analysisDataLoaded &&
				<>
					<div
						className='dashboard-content-wrap'
					>
						<DashboardToolHeader title='Analysis' />
						<DashboardToolEditArea />
					</div>
				</>
			}
		</div>
	)
}

export default DashboardVideoAnalysis
